import { Injector } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { GlobalLoadingService } from 'app/core/services/loading.service';

export function AutoLoading() {
  return function (
    target: unknown,
    propertyKey: string,
    descriptor: PropertyDescriptor,
  ) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: unknown[]) {
      // Obtém o Injector do contexto atual (this)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const injector: Injector = (this as any).injector;
      if (!injector) {
        throw new Error('Injector não disponível no contexto.');
      }

      // Obtém o serviço de loading
      const loadingService = injector.get(GlobalLoadingService);
      loadingService.show();

      const result = originalMethod.apply(this, args);

      if (result instanceof Observable) {
        return result.pipe(finalize(() => loadingService.hide()));
      } else if (result instanceof Promise) {
        return result.finally(() => loadingService.hide());
      }

      return result;
    };

    return descriptor;
  };
}
